import { CORE_PLUGIN, CORE_ROUTER } from '@/core'
import type { Plugin } from '@/plugins'
import { defineStore } from 'pinia'
import {
  container,
  instanceCachingFactory,
  registry,
  singleton
} from 'tsyringe'
import type { Router } from 'vue-router'
import { categories, getSector, getSectorList } from './api/index'

import type { categoriesDetailState, categoriesMenusState, sectorType } from './api/interface/sectorinterface'
import CmsContent from './view/CmsContent.vue'
import CmsSector from './view/CmsSector.vue'
import Home from './view/Home.vue'
import Posts from './view/Posts.vue'
import Product from './view/Product.vue'
import About from './view/AboutUs.vue'
import AI from './view/InspirationAI.vue'
import Mirror from './view/MirrorSpace.vue'
import ProductComment from './view/ProductComment.vue'
import DesginShare from './view/DesginShare.vue'

export const useHomeStore = defineStore('homeStore', {
  state: () => ({
    cmsContentItem: {
      id: 0,
      author: '',
      content: '',
      sector_id: 0,
      currentPage: 1,
      image: '',
      reviewer: '',
      tag: [''],
      title: ''
    },
    sectorsList: [{
      id: 0,
      name: '',
      contents: [{
        author: "",
        content: "",
        id: 0,
        image: "",
        review_status: 0,
        reviewer: "",
        tag: [""],
        title: ""
      }],
      homepage_show: 0
    }],
    categoryList: [{
      id: 0,
      name: ''
    }],
    sectors: [{
      id: 0,
      name: '',
      homepage_show: 0
    }]
  }),
  persist: {
    enabled: true, // 启用
    strategies: [{
      key: 'home',
      // storage 可选localStorage或sessionStorage
      storage: sessionStorage
      // paths 给指定数据持久化
    }]
  },
  getters: {
  },
  actions: {
    async fetch() {
      getSector().then(result => {
        this.sectorsList.length = 0
        result.sectors.forEach((el: sectorType) => {
          this.sectorsList.push({
            id: el.id,
            name: el.name,
            contents: el.contents,
            homepage_show: el.homepage_show
          })
        })
      })
      categories().then(result => {
        this.categoryList.length = 0
        result.categories.forEach((el: categoriesMenusState['categories'][number]) => {
          this.categoryList.push({
            id: el.id,
            name: el.name
          })
        })
      })
      getSectorList().then(result => {
        this.sectors.length = 0
        result.sectors.forEach((el: sectorType) => {
          this.sectors.push({
            id: el.id,
            name: el.name,
            homepage_show: el.homepage_show
          })
        })
      })
    }
  },
})

export const useMirrorStore = defineStore('mirror', {
  state: (): {
    productItem: Partial<categoriesDetailState | any>,
    previewModel: string | any,
    previewClothing: string | any,
    mergePreviewState: boolean,
    currentCategory: number
    mergePreview: string,
    mergePreviewArray: string[],
    isCustomImage: boolean,
    isCustomModel: boolean,
    productFabric: any,
  } => ({
    productItem: {},
    currentCategory: 1,
    previewModel: '',
    previewClothing: '',
    mergePreview: '',
    mergePreviewState: false,
    isCustomImage: false,
    isCustomModel: false,
    mergePreviewArray: [],
    productFabric: ''
  }),
  getters: {
  },
  actions: {}
})

export type HomeOption = {
  cmsContentItem: {
    /** 作者 */
    author: string,
    /** 内容 */
    content: string,
    /** 封面 */
    image: string,
    /** 审核人 */
    reviewer: string,
    /** 标签 */
    tag: string[],
    /** 标题 */
    title: string
  }
}

export type HomeAction = {
  //
}

export type HomeGetter = {
  //
}

export type HomeService = HomeAction & HomeGetter

/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<HomeOption, HomeService>>(
      (c) => c.resolve(HomePLugin)
    ),
  },
])
export class HomePLugin implements Plugin<HomeOption, HomeService> {
  id: string | symbol = ''
  options: HomeOption
  service: HomeService
  constructor() {
    const instantiationStore = useHomeStore()
    this.service = instantiationStore
    this.options = instantiationStore.$state
  }

  init(): void {
    const router = container.resolve<Router>(CORE_ROUTER)
    const routerList = [
      { path: '/', component: Home, name: 'home' },
      { path: '/product', component: Product, name: 'product' },
      { path: '/product/comment/:id', component: ProductComment, name: 'product-comment' },
      { path: '/posts/:id', component: Posts, name: 'cms' },
      { path: '/posts/search', component: CmsSector, name: 'search' },
      { path: '/posts', component: Posts, name: 'posts' },
      { path: '/posts/content/:id', component: CmsContent, name: 'cms-content' },
      { path: '/aboutus', component: About, name: 'aboutus' },
      { path: '/AI', component: AI, name: 'AI' },
      { path: '/mirror', component: Mirror, name: 'mirror' },
      { path: '/desgin_share', component: DesginShare, name: 'DesginShare' },
    ]
    routerList.forEach(item => {
      router.addRoute({ path: item.path, component: item.component, name: item.name })
    })
  }

  initialized(): void {
    //
  }
}
